import React from 'react'
import injectSheet from 'react-jss'
import styles from './select-all.styles'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const SelectAll = ({
  classes,
  deselect,
  onSelect,
  onDeselect,
  className,
  style
}) => (
  <span
    style={style}
    onClick={() => (!deselect ? onSelect() : onDeselect())}
    role="button"
    tabIndex="0"
    className={classNames(
      classes.button,
      { [classes.deselect]: deselect },
      className
    )}>
    All
  </span>
)

SelectAll.propTypes = {
  /** Event listener for selecting action */
  onSelect: PropTypes.func.isRequired,
  /** Event listener for deselecting action */
  onDeselect: PropTypes.func.isRequired,
  /** Set button into deselect state - changes styles and triggers @onDeselect on click */
  deselect: PropTypes.bool,
  /** Additional className to restyle component */
  className: PropTypes.string
}

export default injectSheet(styles)(SelectAll)
